import { CheckCircle2, ArrowRight, Sparkles } from 'lucide-react';

const StripeReturn = () => {
    const handleReturnToApp = () => {
        window.location.href = "swyvery-driver://stripe-return";
    };

    return (
        <div
            style={{
                minHeight: '80vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 1rem',
            }}
        >
            <div style={{ position: 'relative', maxWidth: '28rem', width: '100%' }}>
                {/* Background blur */}
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        backgroundColor: 'rgba(1, 68, 33, 0.05)',
                        borderRadius: '3rem',
                        filter: 'blur(24px)',
                        transform: 'scale(1.1)',
                        pointerEvents: 'none',
                    }}
                />

                <div
                    style={{
                        position: 'relative',
                        backgroundColor: 'white',
                        border: '1px solid rgba(1, 68, 33, 0.1)',
                        borderRadius: '3rem',
                        boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
                        padding: '3rem 2rem',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                        gap: '1.5rem',
                    }}
                >
                    {/* Check circle */}
                    <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div
                            style={{
                                position: 'absolute',
                                width: '6rem',
                                height: '6rem',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(1, 68, 33, 0.1)',
                                animation: 'ping 1s infinite',
                                opacity: 0.2,
                            }}
                        />
                        <div
                            style={{
                                position: 'absolute',
                                width: '5rem',
                                height: '5rem',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(1, 68, 33, 0.1)',
                            }}
                        />
                        <div
                            style={{
                                position: 'relative',
                                width: '4rem',
                                height: '4rem',
                                borderRadius: '50%',
                                backgroundColor: '#58B304',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                            }}
                        >
                            <CheckCircle2 style={{ color: 'white', width: '2rem', height: '2rem' }} />
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
                            <Sparkles style={{ color: '#EEB609', width: '1rem', height: '1rem' }} />
                            <p
                                style={{
                                    fontSize: '0.75rem',
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.1em',
                                    color: '#EEB609',
                                }}
                            >
                                Success
                            </p>
                            <Sparkles style={{ color: '#EEB609', width: '1rem', height: '1rem' }} />
                        </div>

                        <h1 style={{ fontSize: '1.875rem', fontWeight: 700, color: '#58B304', lineHeight: 1.2 }}>
                            Onboarding Complete!
                        </h1>

                        <p style={{ color: '#9CA3AF', fontSize: '0.875rem', lineHeight: 1.5 }}>
                            Your Stripe onboarding has been submitted successfully. Please return to the app to continue.
                        </p>
                    </div>

                    <button
                        onClick={handleReturnToApp}
                        style={{
                            width: '100%',
                            height: '3rem',
                            fontSize: '1rem',
                            fontWeight: 600,
                            borderRadius: '1rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '0.5rem',
                            backgroundColor: '#58B304',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'rgb(19, 150, 63)')}
                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#58B304')}
                    >
                        Return to App
                        <ArrowRight style={{ width: '1rem', height: '1rem' }} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StripeReturn;